import React, {useState } from "react";
import DropdownList from "react-widgets/DropdownList";
import { ErrorMessage } from "formik";
import InputWrapper from "Pages/Profile/InputWrapper";
import { toast } from "react-toastify";
import { Col, FormGroup, Label, Row, Input, Button, } from "reactstrap";
import DatePicker from "react-datepicker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { Form, Formik } from "formik";
import { ReactComponent as PdfIcon } from "../../../assets/utils/images/svgs/PDF.svg";
import * as Yup from "yup";
import moment from "moment";
import { useCommunityList, useDocTypes, useSaveDocument, useSaveUserDocument } from "Api/Common/CommonComponents";



const LossDocumentForm = ({ type, saveDocTypeValue, docTypeName, doc, toggle, updateData, filterCommunity, currentUser, registerWithoutDocument }) => {
    const [formDataState, setFormDataState] = useState({
        docType: '',
        comType: '',
        omschrijving: '',
        gelding: '',
        herinneringDatum: '',
        file: ''
    });
   const { trigger: saveDocument } = useSaveDocument();
const { trigger: saveUserDocument } = useSaveUserDocument();

    const { data: docTypesResponse } = useDocTypes();

  const communityAdminId =
    type === "Gebruikers" ? currentUser?.data?.clooserId : "";

const { data: communityResponse } = useCommunityList(communityAdminId);

    const docTypeList =
        docTypesResponse?.status === true
            ? docTypesResponse.data
            : [];

    const communityList =
        communityResponse?.status === true
            ? communityResponse.data
            : [];

    const validationSchema = Yup.object().shape({
        docType: Yup.string().required("Veld mag niet leeg zijn"),
        comType: Yup.string().required("Veld mag niet leeg zijn"),
        omschrijving: Yup.string().required("Veld mag niet leeg zijn"),
    });

   const handleSubmit = (values, setSubmitting) => {
    setTimeout(() => {
        let formData = new FormData();
        formData.append(
            "saveWithoutDocument",
            registerWithoutDocument ? 1 : 0
        );

        if (!registerWithoutDocument && values.file) {
            formData.append("file", values.file);
        }

        formData.append("docType", values.docType);
        formData.append("comType", values.comType);
        formData.append("omschrijving", values.omschrijving);
        formData.append("gelding", values.gelding);

        if (type !== "Gebruikers") {
            formData.append("herinneringDatum", values.herinneringDatum);
        } else {
            formData.append("iAdminId", currentUser.data.clooserId);
        }

        const requestFn =
            type === "Gebruikers" ? saveUserDocument : saveDocument;

        requestFn({
            method: "post",
            data: formData,
            headers: {
                "content-type": "multipart/form-data",
            },
        })
            .then((response) => {
            
                    if (response.status == true) {
                        toast["success"]("Instellingen zijn bijgewerkt");
                        setFormDataState({
                            docType: "",
                            comType: "",
                            omschrijving: "",
                            gelding: "",
                            herinneringDatum: "",
                            file: "",
                        });
                        toggle();
                        updateData();
                    }
            
            })
            .catch((error) => console.log("catch error:", error))
            .finally(() => setSubmitting(false));
    }, 400);
};


    return (
        <>
            <Formik
                enableReinitialize
                initialValues={formDataState}
                validationSchema={validationSchema}
                onSubmit={
                    (values, { setSubmitting }) => handleSubmit(values, setSubmitting)}
            >
                {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                }) => (
                    <Form onSubmit={handleSubmit}>
                        <div>
                            <Row>
                                <Col md="12" sm="12" lg="12">
                                    {!registerWithoutDocument && (
                                        <FormGroup row >
                                            <Label className={"setting-lebel-style text-start"}>
                                                Geselecteerd bestand
                                            </Label>
                                            <Col sm={12} className="setting-lebel-style text-start">
                                                <PdfIcon /> {doc !== '' && doc.name !== undefined ? doc.name : ''}
                                            </Col>
                                            <ErrorMessage name="file" component="small"
                                                lassName="block mt-2 invalid-feedback" />
                                        </FormGroup>
                                    )}
                                    <div className="custom-styling  mb-3">

                                        <InputWrapper label="Document type *" labelCol={3} className={'setting-lebel-style text-start'}>
                                            <DropdownList dataKey='vName' textField='vLabel'
                                                placeholder="Selecteer"
                                                className={"border rounded text-start"}
                                                onChange={(nextValue) => {
                                                    saveDocTypeValue(nextValue.iDocTypeId, nextValue.vName)
                                                    setFormDataState({ ...formDataState, docType: nextValue.vName })
                                                }}
                                                defaultValue={docTypeName}
                                                name="docType"
                                                data={docTypeList}
                                                required="true"
                                            />
                                        </InputWrapper>
                                        <ErrorMessage name="docType" component="small"
                                            className="block mt-2 invalid-feedback" />
                                    </div>

                                    <div className="custom-styling  mb-3" >
                                        <InputWrapper label="Beschikbaarstellen voor *" labelCol={3} className={'setting-lebel-style text-start'}>
                                            <DropdownList dataKey='iCommunityId' textField='vCommunityName'
                                                placeholder="Selecteer"
                                                className={"border rounded text-start"}
                                                onChange={(nextValue) => {
                                                    setFormDataState({ ...formDataState, comType: nextValue.iCommunityId })
                                                }}
                                                name="comType"
                                                data={communityList}
                                                required="true"
                                            />
                                        </InputWrapper>
                                        <ErrorMessage name="comType" component="small"
                                            className="block mt-2 invalid-feedback" />
                                    </div>

                                    <FormGroup row >
                                        <Label className={"setting-lebel-style text-start"}>
                                            Omschrijving *
                                        </Label>
                                        <Col sm={12} >
                                            <Input
                                                type="text"
                                                name="omschrijving"
                                                className="me-2 input-border-styling"
                                                placeholder="Voer in"
                                                onChange={(val) => {
                                                    setFormDataState({ ...formDataState, omschrijving: val.target.value })
                                                }}
                                            />
                                            <ErrorMessage name="omschrijving" component="small"
                                                className="block mt-2 invalid-feedback" />
                                        </Col>
                                    </FormGroup>


                                    <FormGroup row >
                                        <Label className={"setting-lebel-style text-start"} >
                                            Geldig tott
                                        </Label>
                                        <Col sm={12} >
                                            <div className="input-group-text input-border-styling d-flex justify-content-between">
                                                <DatePicker
                                                    locale="nl"
                                                    name="gelding"
                                                    dateFormat="dd-MM-yyyy"
                                                    className="me-2 border-0 bg-transparent float-start w-100"
                                                    selected={(values.gelding !== '' && values.gelding !== undefined) ? new Date(values.gelding) : ''}
                                                    // selected={''}
                                                    placeholderText={'dd-mm-yyyy'}
                                                    onChange={(val) => {
                                                        setFormDataState({ ...formDataState, gelding: moment(val).format('yyyy-MM-DD') })
                                                    }}
                                                />
                                                <FontAwesomeIcon icon={faCalendarAlt} />
                                            </div>
                                            <ErrorMessage name="gelding" component="small"
                                                className="block mt-2 invalid-feedback" />
                                        </Col>
                                    </FormGroup>

                                    {
                                        type !== "Gebruikers" && <FormGroup row >
                                            <Label className={"setting-lebel-style text-start"}>
                                                Datum herinnering
                                            </Label>

                                            <Col sm={12} >
                                                <div className="input-group-text input-border-styling d-flex justify-content-between">
                                                    <DatePicker
                                                        locale="nl"
                                                        dateFormat="dd-MM-yyyy"
                                                        name="herinneringDatum"
                                                        className="me-2 border-0 bg-transparent float-start w-100"
                                                        selected={(values.herinneringDatum !== '' && values.herinneringDatum !== undefined) ? new Date(values.herinneringDatum) : ''}
                                                        placeholderText={'dd-mm-yyyy'}
                                                        onChange={(val) => {
                                                            setFormDataState({ ...formDataState, herinneringDatum: moment(val).format('yyyy-MM-DD') })
                                                        }}
                                                    />
                                                    <FontAwesomeIcon icon={faCalendarAlt} />
                                                </div>
                                                <ErrorMessage name="herinneringDatum" component="small"
                                                    className="block mt-2 invalid-feedback" />
                                            </Col>
                                        </FormGroup>
                                    }

                                </Col>
                            </Row>
                            <Button className=" align-items-center btn-color-style mb-2 me-2 " size="sm" outline color="primary" type="submit" disabled={isSubmitting}
                            >
                                Opslaan
                            </Button>
                        </div>
                    </Form>

                )}
            </Formik>

        </>
    )
}

export default LossDocumentForm;
